import { FAL_CHECK_CIRCLE, FAR_CIRCLE_PLUS, FAR_CIRCLE_XMARK } from '../../../../const/iconProps';
import i18next from '../../../../strings/i18n/i18n';
var getDeliveryIcon = function (enrolled, isEditEnabled) {
    if (isEditEnabled) {
        return enrolled ? FAL_CHECK_CIRCLE : FAR_CIRCLE_PLUS;
    }
    return enrolled ? FAL_CHECK_CIRCLE : FAR_CIRCLE_XMARK;
};
var getDeliveryMethodTitle = function (preferenceType) {
    return i18next.t("deliveryIconsTitle.".concat(preferenceType.toLowerCase()));
};
var filterKeys = function (preferenceData) {
    return Object.keys(preferenceData)
        .filter(function (key) { return ['preferenceType', 'enrolled'].includes(key); })
        .reduce(function (obj, key) {
        var _a;
        return Object.assign(obj, (_a = {},
            _a[key] = preferenceData[key],
            _a));
    }, {});
};
var getUpdatedPreferenceData = function (currData, formData) {
    return formData
        .filter(function (formDataPreference) {
        return currData.find(function (currDataPreference) {
            return currDataPreference.preferenceType ===
                formDataPreference.preferenceType;
        }).enrolled !== formDataPreference.enrolled;
    })
        .map(function (preference) { return filterKeys(preference); });
};
export { getDeliveryIcon, getDeliveryMethodTitle, getUpdatedPreferenceData };
